import Store from '@app/store';
import Router from '@app/router';
import Blocks from '@app/components/Blocks';
var ModuleContainer = /** @class */ (function () {
    function ModuleContainer() {
        /**
         * Holds an array of loaded modules
         */
        this.modules = [];
    }
    /**
     * Register the given module and
     * load all necessary resources
     *
     * @param module Module to register
     */
    ModuleContainer.prototype.register = function (module) {
        // Check if module is already loaded
        if (this.isModuleLoaded(module)) {
            return console.error("Module " + module.namespace + " already loaded");
        }
        // Add routes
        if (module.routes) {
            Router.addRoutes(module.routes);
        }
        // Register store
        if (module.store) {
            Store.registerModule(module.namespace.substring(module.namespace.indexOf('/') + 1), module.store);
        }
        // Register blocks
        if (module.blocks) {
            for (var blockName in module.blocks) {
                Blocks.registerBlock(blockName, module.blocks[blockName]);
            }
        }
        // Add to loaded modules array
        this.modules.push(module);
        if (window.laravelDebug) {
            console.log("\uD83D\uDCE6 Module loaded [" + module.namespace + "]");
        }
    };
    /**
     * Returns an array of all loaded modules
     */
    ModuleContainer.prototype.getLoadedModules = function () {
        return this.modules;
    };
    /**
     * Check if a given module is already loaded
     *
     * @param module Module to check
     */
    ModuleContainer.prototype.isModuleLoaded = function (module) {
        return this.modules.map(function (m) { return m.namespace; }).indexOf(module.namespace) !== -1;
    };
    /**
     * Returns an array of components
     * tagged with the given tag
     *
     * @param tag Tag to search for
     */
    ModuleContainer.prototype.getTaggedComponents = function (tag) {
        return this.modules
            .filter(function (module) {
            return module.taggedComponents !== undefined
                && module.taggedComponents[tag] !== undefined;
        })
            .map(function (module) { return module.taggedComponents[tag]; })
            .reduce(function (acc, val) { return acc.concat(val); }, []);
    };
    return ModuleContainer;
}());
export default new ModuleContainer;
